if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const prevArrow = `<button type="button" class="slick-prev"><span>Prev</span><svg width="28" height="22" viewBox="0 0 28 22" fill="none" stroke="currentColor" stroke-width="3"><path d="M 28 11 H 3 M 11 -1 L 3 11 L 11 23" /></svg></button>`;
const nextArrow = `<button type="button" class="slick-next"><span>Next</span><svg width="28" height="22" viewBox="0 0 28 22" fill="none" stroke="currentColor" stroke-width="3"><path d="M 0 11 H 25 M 17 -1 L 25 11 L 17 23" /></svg></button>`;
const slickOps = {
	accessibility: true,
	prevArrow: prevArrow,
	nextArrow: nextArrow,
};

(function () {
	// ADD CLASS TO T&C TEXT QUADRANTS
	document.querySelectorAll('.text-modules').forEach((quadSubdiv) => {
		const subClasses = [...quadSubdiv.classList];
		subClasses.forEach((className) => {
			quadSubdiv.parentElement.classList.add(`${className}-wrapper`);
		});
	});

	// JS WRAP LETTERS IN SPANs FOR TYPING ANIMATION
	document.querySelectorAll('.animate-type > span').forEach((span) => {
		const words = span.textContent.split(' ');
		const lettersWrapped = words
			.map(
				(word) =>
					word
						.split('')
						.map((letter) => `<span class="l">${letter}</span>`)
						.join('') //join letters
			)
			.join(' '); // join words

		span.innerHTML = lettersWrapped;
	});

	// ACCORDION TOGGLE
	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.accordion_head').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.accordion_item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	$('.sym-slides').slick(slickOps);

	$('.js-slick-prev').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('.js-slick-next').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});


	if(document.getElementById('groupsrfpform-form')){
		let form = document.getElementById('groupsrfpform-form');
		let button = form.querySelector('button.btn.rfp_form_submit');

		button.setAttribute('aria-label','request for proposal')
	}

})();
